import { userCenteredRegistLogin } from "@/api/interface.js";
import { set_storage } from "@/utils/util.js";

const regist_login = (ajaxPath, from, option = {}) => {
    if (!from.validate()) return;
    return new Promise(async (res, rej) => {
        try {
            let { data } = await userCenteredRegistLogin(ajaxPath, option);
            storage_user_info(data.profile);
            res(data.profile);
        } catch (e) {
            if (e?.response) {
                const errors = e.response.data;
                res(errors);
            }
        }
    });
};
//  登录成功获取用户信息
const storage_user_info = async userInfo => {
    if (!userInfo.username) return;
    set_storage("user_login_sucs", 1);
    //  用jquery 关闭吧
    $(".v-modal .close-btn").trigger("click");
    //  登录成功后直接刷新页面
    window.location.href = "/";
};

export { regist_login };
